import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import ReactInputMask from "react-input-mask";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
import { confirmDialog } from "primereact/confirmdialog";
import { useRequired } from "./Context";
import { useAppContext } from "../../context/AppContext";
//components
import Panel from "../../components/panel/panel";
import Input from "../../components/input/Input";
import Modal from "../../components/modal/Modal";
import Select from "../../components/input/Select";
import FileInput from "../../components/input/FileInput";
import ExportTable from "../../components/button/ExportButton";
import MultipleSelect from "../../components/input/MultipleSelect";
import MoveUsersModal from "./MoveUsersModal";
import ModalGeneralRegister from "./ModalGeneralRegister";
//services
import { getUsers } from "../../services/GeneralRegistration/getUsers";
import { getFormClientConfig } from "../../services/GeneralRegistration/getFormClientConfig";
import { postSchedulesExcel } from "../../services/GlobalRoles/postSchedulesExcel";
import { getSchedules } from "../../services/GlobalRoles/getSchedules";
//hooks
import usePermission from "../../hooks/usePermission";

export default function GeneralRegistration() {
  usePermission("6"); //Visualizar Cadastro Geral;
  const {
    form,
    onClose,
    canAccess,
    tableData,
    setNewClient,
    setTableData,
    idClientEdit,
    loadingTypes,
    clientVisible,
    setIdClientEdit,
    loadingCanAccess,
    setClientVisible,
    setInputRequireds,
    typesregistrationSelect,
    typesregistrationMultiSelect,
  } = useRequired();

  const { permissions } = useAppContext();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [lastData, setLastData] = useState();
  const [showTable, setShowTable] = useState(false);
  const [tableToExport, setTableToExport] = useState(null);

  const [isVisibleModalMove, setIsVisibleModalMove] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [totalRecords, setTotalRecords] = useState(0);
  // eslint-disable-next-line no-unused-vars

  const [mask, setMask] = useState("999.999.999-99");
  const [doc, setDoc] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [visibleFileInput, setVisibleFileInput] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const columns = [
    { field: "id", header: "Código" },
    { field: "name", header: "Nome" },
    { field: "doc", header: "Documento" },
    { field: "contacts", header: "Contatos" },
    { field: "role", header: "Acesso" },
    { field: "registration_types", header: "Tipo de cadastro" },
  ];

  const { data: schedules, refetch: refetchSchedule } = useQuery({
    queryKey: ["schedules"],
    queryFn: () => getSchedules(),
    // refetchOnWindowFocus: false,
    // retry: false,
    enabled: permissions?.includes("2"),
  });

  useEffect(() => {
    handleInputRequired();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function requestFile() {
    var a = document.createElement("a");
    a.href =
      "https://walletlote-arquivos.s3.amazonaws.com/ibsystem/modelo_cadastro_geral.xlsx";
    a.click();
  }

  // Função para montar a mensagem de erro com todos os erros linha por linha
  function buildErrorMessage(errorMessages) {
    let message = "";
    for (const line in errorMessages) {
      if (errorMessages.hasOwnProperty(line)) {
        message += `Linha ${line}: ${errorMessages[line]} | `;
      }
    }
    return message;
  }

  const normalizeDate = value => {
    if (!value) return "";

    // Se for um número (serial Excel), converte
    if (!isNaN(value) && Number(value) > 30000 && Number(value) < 60000) {
      const excelEpoch = new Date(1899, 11, 30);
      const date = new Date(excelEpoch.getTime() + Number(value) * 86400000);

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      return `${yyyy}-${mm}-${dd}`;
    }

    // Se for no formato DD/MM/YYYY
    if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [dd, mm, yyyy] = value.split('/');
      return `${yyyy}-${mm}-${dd}`;
    }

    // Tenta converter diretamente como Date
    const date = new Date(value);
    if (!isNaN(date)) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      return `${yyyy}-${mm}-${dd}`;
    }

    return ""; // Se não for reconhecido
  };

  const transformJson = (jsonData) => {
    return jsonData.slice(4).map((row) => {
      return {
        name: row["Tabela para cadastro de Clientes"] || "",
        doc: row["__EMPTY"] || "",
        cpf_responsible_rfb: row["__EMPTY_1"] || "",
        rg: row["__EMPTY_2"] || "",
        state_registration: row["__EMPTY_3"] || "",
        municipal_registration: row["__EMPTY_4"] || "",
        issuing_authority: row["__EMPTY_5"] || "",
        marital_status: row["__EMPTY_6"] || "",
        nationality: row["__EMPTY_7"] || "",
        profession: row["__EMPTY_8"] || "",
        date_of_birth: normalizeDate(row["__EMPTY_9"]) || "",
        email: row["__EMPTY_10"] || "",
        state: row["__EMPTY_11"] || "",
        cep: (row["__EMPTY_12"] || "")?.replace(/[^\d\-]/g, "") || "",
        city: row["__EMPTY_13"] || "",
        neighborhood: row["__EMPTY_14"] || "",
        address: row["__EMPTY_15"] || "",
        num: row["__EMPTY_16"] || "",
        complement: row["__EMPTY_17"] || "",
        number: row["__EMPTY_18"] || "",
        landline: row["__EMPTY_19"] || "",
        rowNum: row["__rowNum__"] + 1,
      };
    });
  };

  const handleFileChange = async () => {
    const types = getValuesType("registration_types");
    const registration_types_ids = types?.map((type) => type.code);

    if (!types || types.length <= 0) {
      toast.warning("Selecione ao menos um tipo de cadastro");
      return;
    }

    setVisibleFileInput(false);

    const notification = toast.loading(
      "Enviando seus dados, por favor aguarde..."
    );

    const base64Data = selectedFile;

    // Função para converter base64 para ArrayBuffer
    const base64ToArrayBuffer = (base64) => {
      const binaryString = window.atob(base64.split(",")[1]); // Remove o prefixo "data:application/vnd..."
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      return bytes.buffer;
    };

    const arrayBuffer = base64ToArrayBuffer(base64Data);

    try {
      // Usando XLSX para ler o ArrayBuffer e converter o Excel em JSON
      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      // Pegando a primeira planilha
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Converte a planilha em JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const transformedData = transformJson(jsonData);

      // console.log(transformedData);

      // Monta o objeto a ser enviado ao backend
      const obj = {
        datas: transformedData, // O conteúdo do arquivo XLSX convertido para JSON
        type_excel: "register_general",
        registration_types_ids: registration_types_ids,
      };

      const res = await postSchedulesExcel(obj);
      toast.update(notification, {
        render:
          "Planilha de Importação inserida com sucesso, acompanhe o status nas notificações",
        autoClose: 5000,
        type: "info",
        isLoading: false,
      });
    } catch (error) {
      const errorMessage = error.message || "Ocorreu um erro inesperado.";

      toast.update(notification, {
        render: errorMessage,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }

    refetchSchedule();
    setSelectedFile([]);
    resetTypes();
  };

  const handleChangeRegister = async (event) => {
    if (selectedCustomers.length > 0) {
      setIsVisibleModalMove(true);
    } else {
      toast.warning("Selecione ao menos um cliente.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        isLoading: false,
      });
    }
  };

  const spreadsheet = [
    {
      label: "Baixar Modelo",
      icon: "fa fa-solid fa-download",
      command: () => requestFile(),
    },
    {
      label: "Cadastrar por Planilha",
      icon: "fa fa-upload",
      color: "success",
      disabled: schedules?.some(
        (schedule) => schedule.type === "excel_register_general"
      ),
      command: () => handleOption("Planilha de Parcelas", "installment"),
    },
  ];

  const items = [
    {
      template: () => (
        <Link to={"/generalRegistration"} className="p-breadcrumb-link">
          Cadastro Geral
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const handleOption = async (title) => {
    setVisibleFileInput(true);
  };

  const onSubmit = async (data) => {
    data.doc = doc;

    setLastData(data);
    setLoading(true);
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    const response = await getUsers(data);
    setTotalRecords(response.length);

    if (Array.isArray(response)) {
      setTableData(response);
      // console.log(response);
      setShowTable(true);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      reset();
      reset({ name: "", id: "", doc: "" });
    } else {
      toast.update(notification, {
        render: "Hm..Algo não ocorreu bem, verifique sua internet.",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const {
    control: controlTypes,
    reset: resetTypes,
    getValues: getValuesType,
  } = useForm();

  const handleInputRequired = async () => {
    const response = await getFormClientConfig();
    if (Array.isArray(response)) {
      localStorage.setItem("registerGeneral", response);
      setInputRequireds(response);
    }
  };

  const handleEditClient = (id) => {
    setIdClientEdit(id);
    setClientVisible(true);
  };

  const handleNewRegister = () => {
    form.reset();
    setClientVisible(true);
  };

  const watchMask = (value) => {
    if (value.length <= 14) {
      setMask("999.999.999-999");
      setDoc(value);
    } else {
      setMask("99.999.999/9999-99");
      setDoc(value);
    }
  };

  const onSelectionChange = (event) => {
    const value = event.value;
    // console.log(value);
    // console.log(totalRecords);
    setSelectedCustomers(value);
    setSelectAll(value.length === totalRecords);
  };
  const onSelectAllChange = (event) => {
    setSelectAll(event.checked);

    if (event.checked) {
      // Se o checkbox de seleção estiver marcado, selecionar todos os registros
      setSelectedCustomers(tableData);
    } else {
      // Se o checkbox de seleção estiver desmarcado, desmarcar todos os registros
      setSelectedCustomers([]);
    }
  };

  useEffect(() => {
    if (tableData) {
      const dataWithoutIds = tableData.map((t) => ({
        Código: t.id,
        Nome: t.name,
        Email: t.email,
        Documento: t.doc,
        TipoCadastro: t.registration_types,
        Contato: t.contacts,
      }));
      setTableToExport(dataWithoutIds);
    }
  }, [tableData]);

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-xl-4">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-xl-8">
          <div className="row justify-content-end pb-3">
            {permissions &&
              permissions.includes("7") && ( //Cadastro por Planilhas
                <div className="col-md-3">
                  <SplitButton
                    label="Planilhas"
                    icon="fa fa-file"
                    model={spreadsheet}
                    rounded
                    className="p-inputtext-sm w-100 mb-2"
                  />
                </div>
              )}
            {permissions &&
              permissions.includes("8") && ( //Mover Cadastros
                <div className="col-md-5">
                  <Button
                    rounded
                    severity="info"
                    label="Mover Cadastro"
                    icon="fa-solid fa-person-walking-arrow-right"
                    onClick={() => handleChangeRegister()}
                    className="p-inputtext-sm w-100 mb-2"
                  />
                </div>
              )}
            {permissions &&
              permissions.includes("9") && ( //Criar Cadastros
                <div className="col-md-4">
                  <Button
                    rounded
                    severity="success"
                    label="Novo Cadastro"
                    icon="fa fa-user-plus"
                    onClick={() => handleNewRegister()}
                    className="p-inputtext-sm w-100 mb-2"
                  />
                </div>
              )}
          </div>
        </div>
      </div>
      <Modal
        visible={visibleFileInput}
        dynamicTitle={"Planilha de Clientes"}
        onHide={(e) => setVisibleFileInput(false)}
      >
        <form>
          <div className="col-md-8 pb-2  my-2">
            <MultipleSelect
              require={true}
              name="registration_types"
              label="Selecione os Tipos de Cadastro"
              control={controlTypes}
              options={typesregistrationMultiSelect}
              disabled={loadingTypes ? true : false}
            />
          </div>
          <div className="col-md-12 my-2">
            <FileInput
              isMultiple={false}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
              onConfirmButton={handleFileChange}
              buttonConfirm={true}
              type="file"
              base64={true}
              typeFile=".xlsx,.xls"
              name="excelUpload"
              id="excelUpload"
              title="Inserir Planilha"
              icon="fa-rotate-left"
            />
          </div>
        </form>
      </Modal>
      <MoveUsersModal
        visible={isVisibleModalMove}
        setVisible={setIsVisibleModalMove}
        selectedCustomers={selectedCustomers}
        setSelectedCustomers={setSelectedCustomers}
      />
      <Panel title="Filtro de Cadastro">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row justify-content-end">
            <div className="col-xl-3 col-md-6" style={{ paddingTop: "1px" }}>
              <Input
                name="name"
                control={control}
                errors={errors}
                label="Nome"
              />
            </div>
            <div className="col-xl-3 col-md-6 mb-3">
              <ReactInputMask
                mask={mask}
                maskChar={null}
                value={doc}
                onChange={(event) => watchMask(event.target.value)}
                placeholder="CPF / CNPJ"
                className={`input-cpf ${doc ? "input-filled" : ""}`}
              />
            </div>
            <div className="col-xl-2 col-md-4" style={{ paddingTop: "1px" }}>
              <Input
                name="id"
                control={control}
                errors={errors}
                label="Nº de Cadastro"
              />
            </div>
            <div className="col-xl-2 col-md-4 mb-3">
              <Select
                name="registration_type_id"
                label={loadingTypes ? "Carregando.." : "Tipos de Cadastros"}
                errors={errors}
                control={control}
                options={typesregistrationSelect}
                disabled={loadingTypes}
              />
            </div>
            {((canAccess && canAccess.length !== 0) || loadingCanAccess) && (
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="access_id"
                  label={loadingCanAccess ? "Carregando.." : "Acessos"}
                  errors={errors}
                  control={control}
                  options={canAccess}
                  disabled={loadingCanAccess}
                />
              </div>
            )}
            {(canAccess && canAccess.length !== 0) || loadingCanAccess ? (
              <div className="col-xl-1 col-md-2 mb-3">
                <div className="text-center">
                  <Button
                    type="submit"
                    icon="fa fa-search"
                    loading={loading}
                    aria-label="Search"
                    className={`rounded-3 py-2.5 w-100`}
                  />
                </div>
              </div>
            ) : (
              <div className="col-md-2 mt-3">
                <div className="text-center">
                  <Button
                    type="submit"
                    icon="fa fa-search"
                    loading={loading}
                    aria-label="Search"
                    className={`rounded-3 py-2.5 w-100`}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </Panel>
      {showTable && (
        <Panel mainCss="mt-4">
          <>
            <div className="px-2 pb-3">
              <ExportTable
                tableData={tableToExport}
                exportColumns={exportColumns}
                tabelaKey={"Relatório de Cadastros"}
                globalFilterValue={globalFilterValue}
                onGlobalFilterChange={(e) =>
                  setGlobalFilterValue(e.target.value)
                }
              />
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="multiple"
                rowsPerPageOptions={[5, 25, 100]}
                value={tableData}
                totalRecords={tableData}
                selectAll={selectAll}
                selection={selectedCustomers}
                onSelectionChange={onSelectionChange}
                onSelectAllChange={onSelectAllChange}
                globalFilter={globalFilterValue}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                <Column
                  field="id"
                  headerStyle={{ width: "3rem" }}
                  selectionMode="multiple"
                  filterMatchMode={FilterMatchMode.CONTAINS}
                />
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    filterMatchMode={FilterMatchMode.CONTAINS}
                  />
                ))}
                {permissions &&
                  permissions.includes("11") && ( //Editar Cadastro
                    <Column
                      header="Editar"
                      body={(rowData) => (
                        <div className="text-center">
                          <button
                            className="btn btn-success btn-btn-sm"
                            onClick={() => handleEditClient(rowData.id)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                        </div>
                      )}
                    />
                  )}
              </DataTable>
            </div>
          </>
        </Panel>
      )}
      {/* <GeneralRegistrationModal
        visible={clientVisible}
        onClose={onClose}
        form={form}
        setNewClient={setNewClient}
        editClient={idClientEdit && idClientEdit}
      /> */}
      <ModalGeneralRegister
        visible={clientVisible}
        onHide={onClose}
        setVisible={setClientVisible}
        editClient={idClientEdit && idClientEdit}
      />
    </>
  );
}
